module.exports = __webpack_public_path__ + "static/img/12.36f68a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/7/12.png
// module id = 290
// module chunks = 0